<template>
  <div class="modal fade inactivity" tabindex="-1" :id="modalId" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content text-center">
        <div class="divToCenter">
            <div
              class="d-flex justify-content-center"
              v-bind:style="stepSpanStyle"
            >
              <span class="icon icon-cross"></span>
            </div>
        </div>
        <div class="modal-body pt-2 pb-4">
          <h5>{{ title }}</h5>
          <p>{{ message }}</p>
          <ColoredButton @click="deny" class="w-auto">Close</ColoredButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ColoredButton from './ColoredButton';
  export default {
    components: {
      ColoredButton
    },
    props: {
      modalId: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        title: "Something wrong",
        message: null,
        confirmCallback : null,
        denyCallback : null,
        remainingTime: 300,
        disableRefreshButton: true,
        countDown: null,
      }
    },
    watch : {
      showModal: function(){
        var hashModalId = "#" + this.modalId;
        if(this.showModal) {
          this.message = this.showModal.message;
          this.title = this.showModal.title || this.title;
          $(hashModalId).modalbs5({
            show: true,
            backdrop: 'static',
            keyboard: false
          })
        }
        else{
          $(hashModalId).modalbs5('hide');
        }
      },
      remainingTime(val) {
        if (val <= 0) {
          this.disableRefreshButton = false;
          clearInterval(this.countDown)
        }
      },
      logo: function() {
        var fail = "<i class='icon-cross'></i>";
        return "<strong>" + fail + "</strong>";
      },
    },
    methods: {
      deny() {
        this.$store.commit('SET_SHOW_MODAL_ERROR', false);
      }
    },
    computed: {
      showModal() {
        return this.$store.getters.GET_SHOW_MODAL_ERROR;
      },
      stepSpanStyle() {
        var color = "#D7010B";
        return {
          border: "1px solid " + color,
          color: "#F7F7F7",
          height: "3rem",
          width: "3rem",
          "border-radius": "50%",
          "background-color": color,
          "font-size": "1.125rem",
          "align-items": "center !important",
          "justify-content": "center !important"
        };
      }
    },
    mounted() {
      this.countDown = setInterval(() => {
        this.remainingTime--;
      }, 1000);
    }
  }
</script>

<style scoped>

.divToCenter {
    margin: 1rem auto;
}
</style>
